export default [
    {
        show(row, extra) {
            return (
                row.fkfs === '1'
            )
        },
        tag: 'my-tag',
        type: 'primary',
        text(row) {
            return `支付宝`;
        }
    }, {
        show(row, extra) {
            return (
                row.fkfs === '9'
            )
        },
        tag: 'my-tag',
        type: 'warning',
        text(row) {
            return `线下支付，点击查看凭证`;
        },
        click() {
            this.$emit('showfile')
        }
    }, {
        show(row, extra) {
            return (
                row.fkfs === '3'
            )
        },
        tag: 'my-tag',
        type: 'info',
        text(row) {
            return `聚合支付`;
        }
    }, {
        show(row, extra) {
            return (
                row.fkfs === '4'
            )
        },
        tag: 'my-tag',
        type: 'info',
        text(row) {
            return `银联`;
        }
    },
]
